<template>
  <v-dialog v-model="show" max-width="350" persistent>
    <v-card>
      <v-card-text align="center">
        <br />
        <br />
        <!-- <img align="center" src="../assets/icon/close-circle-outline.svg" /> -->
        <v-icon large color="red"> mdi-close-circle-outline </v-icon>
        <br />
        <br />
        <h4 class="text-loading-color">{{ msg }}</h4>
        <br />
        <v-btn
          color="#8246AF"
          width="100"
          outlined
          rounded
          @click.stop="show = false"
          >{{ $t("msgerror.btn") }}</v-btn
        >
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["visible", "textError", "type"],
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    msg: {
      get() {
        return this.textError;
      },
      set(value) {
        if (!value) {
          this.$emit("msgerror");
        }
      },
    },
  },
};
</script>
